import React, { useRef, useState, useEffect } from "react"

import axios from 'axios'   // axios is used for API "get" and "post" calls
import { useHistory } from "react-router-dom"
import { ChatEngine } from "react-chat-engine"

// NOTE get the useAuth() which will give us the AuthContext populated with user data.
// (AuthContext gets all the data from the "value" object in AuthContext.Provider function call (AuthContext.js))
// and we've defined "value" to be the "user" (user data))
import { useAuth } from "../contexts/AuthContext"

import { auth } from "../firebase"

export default function Chats() {

  const didMountRef = useRef(false)
  const [ loading, setLoading ] = useState(true)

  // get user data from useAuth() (which is a context containing user data returned from firebase)
  // Now the user variable is populated with user data from AuthContext (which gets user data from "value" object)
  const { user } = useAuth() 
  
  // in-order to re-navigate to "/" inside handleLogout(), call useHistory() "hook" and store it in history variable
  const history = useHistory()

  // console.log(user);

  async function handleLogout() {
    await auth.signOut()
    history.push("/")
  }

  // API function to handle profile image of accounts (from firebase)
  async function getFile(url) {
    let response = await fetch(url);
    let data = await response.blob();   // blobs are generally images/files that we want to transfer in binary format
    return new File([data], "test.jpg", { type: 'image/jpeg' });
  }

  useEffect(() => {
    if (!didMountRef.current) {
      didMountRef.current = true

      if (!user || user === null) {
        history.push("/");
        return;
      }
      
      // Checking if user already exists; => pull all it's chat data from the specified url by passing meta-data
      // in headers & then set loading state = false
      axios.get(
        'https://api.chatengine.io/users/me/', { 
          headers: { 
          "project-id": process.env.REACT_APP_CHAT_ENGINE_ID,
          "user-name": user.email,
          "user-secret": user.uid
        }
      })
      .then(() => setLoading(false))

      // If we don't already have a chat-engine profile, i.e new user => create a new profile
      .catch(e => {
        // formData will allow us to store all the information we need about a user
        let formdata = new FormData();
        formdata.append('email', user.email);
        formdata.append('username', user.email);
        formdata.append('secret', user.uid);

        // get the user's profile image from the user object returned from firebase
        getFile(user.photoURL)
        .then(avatar => {
          formdata.append('avatar', avatar, avatar.name)

          // create the new user. If user creation is successful, then set loading = false
          // otherwise, console log the error (a Post request by passing the formdata created above).
          // Meta-data passed in 'headers' will be the project key in the chat-engine API
          axios.post(
            'https://api.chatengine.io/users/',
            formdata,
            { headers: { "private-key": process.env.REACT_APP_CHAT_ENGINE_KEY }}
          )
          .then(() => setLoading(false))
          .catch(e => console.log('e', e.response))
        })
      })
      // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

    }
  }, [user, history])//---> call useEffect() whenever the user or history changes (i.e on sign-in or re-navigation)
  
  // user will not be defined when we first load the page bcz it won't yet be fetched.
  // So, if there is no user OR if we are currently loading the user then - give a loading msg
  if (!user || loading) return "Loading..."

  return (
    <div className='chats-page'>
      <div className='nav-bar'>
        <div className='logo-tab'>
          Cryptomania
        </div>

        <div onClick={handleLogout} className='logout-tab'>
          Logout
        </div>
      </div>

      {/* ChatEngine component (self closing). It takes the following "props" as per the documentation */}
      <ChatEngine 
        height='calc(100vh - 66px)'
        projectID={process.env.REACT_APP_CHAT_ENGINE_ID}
        userName={user.email}
        userSecret={user.uid}
      />
    </div>
  )
}


